import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";

export interface AccessGroupConfirmationModalProps {
  i18nRoot: string;
  onConfirm: () => void;
}

// this is a modal that is used to confirm the action of changing
// the access type from legacy to access groups
const AccessGroupConfirmationModalComponent = ({
  onConfirm = noop,
  i18nRoot,
}: AccessGroupConfirmationModalProps) => {
  const modal = useModal();
  return (
    <ConfirmationModal
      isOpen={modal.visible}
      onClose={modal.hide}
      onConfirm={() => {
        onConfirm();
        void modal.hide();
      }}
      confirmText={t([i18nRoot, "confirm_cta"])}
      confirmVariant="circle"
      title={t([i18nRoot, "title"])}
    >
      {t([i18nRoot, "description"])}
    </ConfirmationModal>
  );
};

const AccessGroupConfirmationModal = ModalManager.create(
  (props: AccessGroupConfirmationModalProps) => (
    <AccessGroupConfirmationModalComponent {...props} />
  ),
);

export const useAccessGroupConfirmationModal = () =>
  useModal(AccessGroupConfirmationModal);
